import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12l3 3l3 -3l-3 -3z","key":"svg-0"}],["path",{"d":"M15 12l3 3l3 -3l-3 -3z","key":"svg-1"}],["path",{"d":"M9 6l3 3l3 -3l-3 -3z","key":"svg-2"}],["path",{"d":"M9 18l3 3l3 -3l-3 -3z","key":"svg-3"}]]

const IconComponents = createReactComponent('outline', 'components', 'Components', __iconNode);

export default IconComponents;